// extracted by mini-css-extract-plugin
export var circle = "_i-2";
export var icon = "_i-a";
export var iconHighlight = "_i-0";
export var lg = "_i-8";
export var md = "_i-7";
export var outline = "_i-4";
export var sm = "_i-6";
export var square = "_i-1";
export var xl = "_i-9";
export var xs = "_i-5";
export var xxs = "_i-3";